<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} đối tượng theo dõi
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Họ tên">
                      <el-input
                        type="text"
                        v-model="mData.tableRules.dataSearch.value['doi_tuong.ten']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Số điện thoại">
                      <el-input
                        type="text"
                        v-model.trim="mData.tableRules.dataSearch.value['doi_tuong.so_dien_thoai']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="CMND">
                      <el-input
                        type="text"
                        v-model.trim="mData.tableRules.dataSearch.value['doi_tuong.cmt']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Mã thẻ">
                      <el-input
                        type="text"
                        v-model.trim="mData.tableRules.dataSearch.value['doi_tuong.card_code']"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tỉnh/TP:">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value['co_so_cach_ly.ma_tinh']"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                        @change="fn_changeTinh_cscl(mData.tableRules.dataSearch.value['co_so_cach_ly.ma_tinh'], true)"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmTinh_cscl"
                          :key="item.MA_TINH"
                          :label="item.TEN_TINH"
                          :value="item.MA_TINH"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Quận/Huyện:">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value['co_so_cach_ly.ma_huyen']"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                        @change="fn_changeHuyen_cscl(mData.tableRules.dataSearch.value['co_so_cach_ly.ma_tinh'], mData.tableRules.dataSearch.value['co_so_cach_ly.ma_huyen'], true)"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmHuyen_cscl"
                          :key="item.MA_QUAN"
                          :label="item.TEN_QUAN"
                          :value="item.MA_QUAN"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item label="Xã/Phường:">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value['co_so_cach_ly.ma_xa']"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmXa_cscl"
                          :key="item.MA_XA"
                          :label="item.TEN_XA"
                          :value="item.MA_XA"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Cơ sở cách ly">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value['co_so_cach_ly.ma_co_so']"
                        :placeholder="aLang.c_select"
                        filterable
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.dmCoSo"
                          :key="item.madiadiem"
                          :label="item.tendiadiem"
                          :value="item.madiadiem"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <b-row></b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>Thêm đối tượng</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          ref="tableDoiTuongTheoDoi"
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
          :row-class-name="tableRowClassName"
          :row-style="handCellMouse"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="doi_tuong.ten"
            label="Họ tên"
            width="auto"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>
          <el-table-column
            prop="doi_tuong.so_dien_thoai"
            label="Số điện thoại"
            width="150"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>
          <el-table-column
            prop="doi_tuong.cmt"
            label="CMND"
            width="120"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>
          <el-table-column
            prop="doi_tuong.quoc_tich"
            label="Quốc tịch"
            width="120"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>
          <el-table-column
            prop="co_so_cach_ly.ten_co_so"
            label="Cơ sở cách ly"
            width="160"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>
          <el-table-column
            prop="ngay_theo_doi"
            label="Ngày theo dõi"
            width="150"
            align="center"
            :formatter="fn_formatterDatetime"
            :sortable="mData.tableRules.allowSorting"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_theodoi(scope.row)"
                v-b-popover.hover.left="'Bảng theo dõi'"
              >
                <i class="icon-calendar"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_gotoKhamDich(scope.row)"
                v-b-popover.hover.left="'Thông tin khám dịch'"
              >
                <i class="fa fa-stethoscope"></i>
              </el-button>

              <el-button
                size="mini"
                @click="fn_handle('update', scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>

              <el-button
                size="mini"
                @click="fn_handle('detail', scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DoiTuongTheoDoiModel from "./DoiTuongTheoDoiModel";
import DoiTuongTheoDoiApi from "../../../moduleApi/DoiTuongTheoDoiApi";
import * as moment from "moment";
import Hssk831Api from "../../../moduleApi/Hssk831Api";
import KhaoSatApi from "../../../moduleApi/KhaoSatApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DoiTuongTheoDoi", //requied
        tableRules: MethodService.copyObject(DoiTuongTheoDoiModel.tableRules),
        dataDefault: {
          dmTinh_cscl: [],
          dmHuyen_cscl: [],
          dmXa_cscl: [],
          dmCoSo: [],
          dataTrieuTrung: []
        }
      }
    };
  },

  methods: {
    //
    async getKhaiBaoDichApi() {
      let { MaTinhThanhCSKCB: ma_tinh } = MethodService.getCurrentUserBS();
      try {
        let res = await DoiTuongTheoDoiApi.get_many(ma_tinh);
        let result = await DoiTuongTheoDoiApi.get_many(ma_tinh, res.meta.total);
        return result;
      } catch (error) {
        return [];
      }
    },
    async convertLastSurvey() {
      let datas = await this.getKhaiBaoDichApi();
      let dataNeed = [];
      if (datas && datas.result && datas.result.length > 0) {
        datas.result.forEach(data => {
          if (data && data.LastSurvey) {
            data.LastSurvey.idDoituong = data.DoiTuong.id;
            dataNeed.push(data.LastSurvey);
          }
        });
      }
      this.mData.dataDefault.dataTrieuTrung = [];
      this.mData.dataDefault.dataTrieuTrung = dataNeed;
    },
    //backgrouptable
    tableRowClassName({ row }) {
       this.TrieuTrung = [];
      let datas = this.mData.dataDefault.dataTrieuTrung;
      if (datas && datas.length > 0) {
        datas = datas.filter(data => data.idDoituong === row.id);

        if (datas && datas[0] && datas[0].result) {
          this.TrieuTrung = datas[0].result.reduce((elemnt1, elemnt2) => {
            if (elemnt2.code == "col_ho" && elemnt2.value == "Có") {
              elemnt1.push("Ho");
            }
            if (elemnt2.code == "col_sot" && elemnt2.value == "Có") {
              elemnt1.push("Sốt");
            }
            if (elemnt2.code == "col_khotho" && elemnt2.value == "Có") {
              elemnt1.push("Khó Thở");
            }
            if (elemnt2.code == "col_viemphoi" && elemnt2.value == "Có") {
              elemnt1.push("Viêm phổi");
            }
            if (elemnt2.code == "col_dauhong" && elemnt2.value == "Có") {
              elemnt1.push("Đau họng");
            }
            if (elemnt2.code == "col_metmoi" && elemnt2.value == "Có") {
              elemnt1.push("Mệt mỏi");
            }
            return elemnt1;
          }, []);
        }
      }

      if (
        this.TrieuTrung &&
        this.TrieuTrung.length > 0 &&
        this.TrieuTrung.length < 3
      ) {
        return "warning-row";
      } else if (this.TrieuTrung && this.TrieuTrung.length > 3) {
        return "error-row";
      }
      return "success-row";
    },
    handCellMouse() {
      this.$refs.tableDoiTuongTheoDoi.$options._parentVnode.elm.classList.remove(
        "el-table--enable-row-hover"
      );
    },
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }
      let res = await DoiTuongTheoDoiApi.list(dataFilter);
      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    // changeData(data) {},

    //click button
    fn_handle(type, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await DoiTuongTheoDoiApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await DoiTuongTheoDoiApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (this.mData.tableRules.dataSearch.value["doi_tuong.ten"])
            this.mData.tableRules.dataSearch.value[
              "doi_tuong.ten"
            ] = MethodService.trimTextData(
              this.mData.tableRules.dataSearch.value["doi_tuong.ten"]
            );
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },

    async fn_initDataDefault() {
      let res_LoadDMTinhThanh = await Hssk831Api.LoadDMTinhThanh();
      this.mData.dataDefault.dmTinh_cscl = res_LoadDMTinhThanh.data
        ? res_LoadDMTinhThanh.data
        : [];
    },

    async fn_theodoi(row) {
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-baocao",
        params: { id: row.id },
        query: {
          card_code: row.doi_tuong ? row.doi_tuong.card_code : ""
        }
      });
    },

    fn_gotoKhamDich(row) {
      this.$router.push({
        name: "Admin-KhamDich-list",
        query: { card_code: row.doi_tuong.card_code }
      });
    },

    async fn_changeTinh_cscl(MaTinhThanh, isReset) {
      if (isReset) {
        this.mData.tableRules.dataSearch.value["co_so_cach_ly.ma_xa"] = null;
        this.mData.tableRules.dataSearch.value["co_so_cach_ly.ma_huyen"] = null;
        this.mData.tableRules.dataSearch.value["co_so_cach_ly.ma_co_so"] = null;
      }
      let res = await Hssk831Api.LoadDMQuanHuyen(MaTinhThanh);
      this.mData.dataDefault.dmHuyen_cscl = res.data;

      let res_dm = await KhaoSatApi.LoadDMCoSoCachLy(MaTinhThanh);
      if (res_dm.data && res_dm.data.length > 0) {
        res_dm.data.map(item => {
          item.madiadiem = item.madiadiem.toString();
        });
      }
      this.mData.dataDefault.dmCoSo = res_dm.data;
    },
    async fn_changeHuyen_cscl(MaTinhThanh, MaQuanHuyen, isReset) {
      if (isReset) {
        this.mData.tableRules.dataSearch.value["co_so_cach_ly.ma_xa"] = null;
      }
      let res = await Hssk831Api.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      this.mData.dataDefault.dmXa_cscl = res.data;
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
    this.fn_initDataDefault();
  },
  mounted() {
    this.convertLastSurvey();
    this.fn_initTable();
  }
};
</script>
<style >
.el-table .warning-row {
  background: #ffff0087 !important;
}
.el-table .error-row {
  background: #ff2f0087 !important;
}
.el-table .success-row {
  background-color: white !important;
}

.error-row:hover {
  background-color: #ff2f00b8 !important;
}
.warning-row:hover {
  background-color: #ffff00e0 !important;
}
.success-row:hover:hover {
  background-color: #dcdcdc52 !important;
}
</style>